/**
    商品店铺
    商品评价 5.0 服务态度 5.0 物流速度 5.0
**/
<template>
  <div class="shopInfo" v-if="shopInfo.name">
    <!-- <h4> <a class="item_link" :href="shopInfo.shopLink"> </a></h4> -->
    <h4> 
      <router-link v-if="supplieStore==0?true:false" :to='`/shopStore?storeId=${shopInfo.bxmId}`'>{{shopInfo.name || '--'}}</router-link>
      <router-link v-if="supplieStore" :to='`/shopStore_supplier?storeId=${shopInfo.bxmId}`'>{{shopInfo.name || '--'}}</router-link>
    </h4>
    <div class="shopInfo_center">
            <div class="shopImg">
                <el-image :src="`${shopInfo.logo}`" class="bg">
                    <div slot="error" class="image-slot bg-font-size-m">
                            <i class="el-icon-s-shop"></i>
                    </div>
                </el-image>
            </div>
        <div :span="16" style="text-align: center;">
            <div class="shopInfo_center_text">商品评价 &nbsp;<i>{{storeScore.matchScore || 5.0}}</i></div> 
            <div class="shopInfo_center_text">服务态度 &nbsp;<i>{{storeScore.serviceScore || 5.0}}</i></div> 
            <div class="shopInfo_center_text">物流速度 &nbsp;<i>{{storeScore.speedScore || 5.0}}</i></div> 
        </div>
    </div>
    <el-divider></el-divider>
    <div class="twoButtom" v-if="isshow==1?true:false">
        <router-link v-if="supplieStore==0?true:false" :to='`/shopStore?storeId=${shopInfo.bxmId}`'>进店逛逛</router-link>
        <router-link v-if="supplieStore" :to='`/shopStore_supplier?storeId=${shopInfo.bxmId}`'>进店逛逛</router-link>
        <a v-if="shopInfo.isCollect==0?true:false" @click="addCollectionHandle(shopInfo.bxmId)"><i class="el-icon-star-off"></i> 关注店铺</a>
        <a v-if="shopInfo.isCollect==1?true:false"  @click="removeCollectionHandle(shopInfo.bxmId)"><i class="el-icon-star-on"></i> 已关注</a>
    </div>
  </div>
</template>
<script>
import { addCollection,removeCollection,storerList,score } from "@/api/xunyou";
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      // storeScore:{},
      // shopInfo:{},
    //   centerDialogVisible: false,
    //   successInfo: true,
    //   addGoodsName: "洁面膏100g温和清洁泡沫",
    //   checked1: "",
	//   checked2: "",
	//   rightGoodsList:[],
    };
  },
 props: ['isshow','shopInfo','storeScore','supplieStore'],
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    console.log(this.shopInfo.bxmId,'sodifosdoifp===================jljkjl')
    if(undefined!=this.shopInfo.bxmId)
    {
      this.getScore(this.shopInfo.bxmId)
    }
    
  },
  mounted(){
    
    // this.searchStorerList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 获取评价列表
    getScore(id) {
            score({
              bxmId:id,
              type:1,//1.店铺评级，2.商品评价
            })
              .then((res) => {
                  if (res.code == 0) {
                    this.storeScore = res.data
                }
              })
              .catch((err) => {
                this.$message.error("查询商品评价失败，请稍后再试！");
              });
      },

    //  // 店铺查询
    // searchStorerList() {
    //   this.loading = true;
    //   storerList({
    //     userId:this.userInfo.userId,
    //     bxmId:this.storeId,
    //   })
    //     .then((res) => {
    //         this.loading = false;
    //         this.shopInfo = res[0];          
          
    //     })
    //     .catch((err) => {
    //       this.editFormVisible = false;
    //       this.loading = false;
    //       this.$message.error("店铺查询失败，请稍后再试！");
    //     });
    // },
     // 添加关注
    addCollectionHandle(id) {
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
      // this.loading = true;
      const req ={
        type:2, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 店铺id
      }
      addCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.shopInfo.isCollect = 1
            // this.searchStorerList()
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
    // 取消关注
    removeCollectionHandle(id) {
      // this.loading = true;
      const req ={
        type:2, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 店铺id
      }
      removeCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.shopInfo.isCollect = 0
            // this.searchStorerList()
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang='less'>
.shopInfo {
  /* width:"200px"; */
  /* background: pink; */
  /* padding: 10px; */
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  margin-right: 10px;
  margin-bottom: 20px;
}
.shopInfo h4 {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  font: 700 14px "microsoft yahei";
  overflow: hidden;
  background-color: #dddddd;
}
.shopInfo_center{
    padding: 10px;
    box-sizing: border-box;
    font-size: 12px;
    display: flex;
    justify-content: space-around;
}
.shopImg {
    width: 65px;
}
.shopInfo_center_text {
    line-height: 20px;
    color: #999;
}
.el-divider--horizontal{
    margin:0;
}
.twoButtom {
    font-size: 12px;
    display: inline-block;
    display: flex;
    justify-content: space-around;
    padding: 10px 5px;
    box-sizing: border-box;
    /deep/i.el-icon-star-on {
      color: #78b942;
      vertical-align: text-bottom;
    }
    /deep/i.el-icon-star-off{
      vertical-align: text-bottom;
    }
}
.twoButtom a {
    background: #dddddd;
    border: 1px solid #c0c0c0;
    width: 40%;
    text-align: center;
    padding: 5px 0px;
    box-sizing: border-box;
    cursor: pointer;
}

.left_product {
  padding: 10px;
}
.left_product li {
  margin-bottom: 30px;
}
.pro-price {
  margin: 10px 0;
  color: #78b942;
}
.pro_name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 14px;
  margin: 10px 0;
}
.img-responsive {
  width: 100%;
}

.nodate{
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
}
.nodate .first {
	margin: 40upx 0 12upx;
	font-size: 28upx;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/components/shopStoreItem.vue